export default __webpack_public_path__ + "static/media/deeplearning_ai_logo.f5e1bd28.png";